var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 200",
    style: {
      enableBackground: "new 0 0 600 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.55;fill:#FFFFFF;}\n\t.st2{opacity:0.25;fill:#FFFFFF;}\n\t.st3{opacity:0.7;fill:#FFFFFF;}\n\t.st4{opacity:0.4;fill:#FFFFFF;}\n\t.st5{opacity:0.55;}\n\t.st6{opacity:0.7;}\n\t.st7{opacity:0.85;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.7,145.1c-13.2,0-22.6-6.2-25.4-16.8h14.5c1.9,3.6,6.6,5.3,10.7,5.3c6.9,0,12-4.7,12-11.2v-4l-2,1.3 c-3.7,2.4-8.1,3.6-12.6,3.6c-14,0-24.2-10.3-24.2-24.4c0-13.9,10.4-24.4,24.2-24.4c5.7,0,11,1.9,15.3,5.6l1.3,1.1l2.6-5.1l9.8,0 v44.2C235.8,135.6,225.8,145.1,209.7,145.1z M209.8,86.5c-7.1,0-12.3,5.2-12.3,12.5c0,7.3,5.2,12.5,12.3,12.5 c7.1,0,12.2-5.3,12.2-12.5C222,91.8,216.8,86.5,209.8,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.2,126.4c-15.9,0-27.4-10.9-27.4-25.9s11.5-25.9,27.4-25.9s27.4,10.9,27.4,25.9S290.1,126.4,274.2,126.4z  M274.2,87.7c-7.2,0-12.4,5.4-12.4,12.8s5.2,12.8,12.4,12.8c0,0,0,0,0,0c3.5,0,6.6-1.3,8.9-3.6c2.2-2.3,3.5-5.6,3.5-9.2 C286.6,93.1,281.4,87.7,274.2,87.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.6,
    y: 57.7,
    className: "st0",
    width: 15,
    height: 67
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.7,124.8V88.3h-8.5l0-11.2h8.7v-6.2c0-9.8,5.2-14.9,15.2-14.9h11v10.9h-6.5c-3.3,0-5.5,2.2-5.5,5.5v4.8 h12.1v11.2h-11.5v36.5H346.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.5,126.4c-5.5,0-10.5-1.8-14.6-5.2l-1.4-1.1l-2,4.6h-10.8v-67h14.8v21.5l2-1.3c3.5-2.2,7.7-3.3,12-3.3 c15.1,0,25.6,10.7,25.6,25.9S426.6,126.4,411.5,126.4z M409.2,87.5c-7.3,0-12.8,5.6-12.8,13c0,7.4,5.5,13,12.8,13 s12.8-5.6,12.8-13C422,93.1,416.5,87.5,409.2,87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.6,126.4c-15.1,0-26.5-11.2-26.5-26c0-15,11.1-25.9,26.5-25.9c15.4,0,26.6,10.7,26.6,25.5 c0,1.1-0.1,2.2-0.2,3.3h-38.5l0.3,1.6c1.3,6.4,5.4,10,11.8,10c4.3,0,7.9-1.8,10-4.8h14.9C492.6,120.2,483.2,126.4,471.6,126.4z  M471.6,85.7c-5.8,0-9.8,3.1-11.4,8.8l-0.5,1.7h24.2l-0.5-1.7C481.7,88.8,477.5,85.7,471.6,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.1,124.8V76.2h9.6L522,83l1.3-1.5c3.3-3.8,7.3-5.5,13.1-5.5h3.3v13.5h-5.5c-6.9,0-10.2,3.4-10.2,10.6 v24.7H509.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571.2,124.8c-10.6,0-16.9-6.3-16.9-17V87.1H545v-2.3l22.2-23.6h1.7v15h12.9v10.9h-12.4v17.6 c0,4.4,2.8,7.2,7.3,7.2h5.4v12.8H571.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.3,38L47.3,38C30,38,16,52,16,69.2v0h31.3V38z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 38,
    className: "st2",
    width: 31.3,
    height: 31.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 69.3,
    className: "st3",
    width: 31.3,
    height: 31.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91,38 57.7,38 47.3,38 47.3,69.3 78.5,69.3 98.9,69.3 109.8,63.5 109.8,38  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "88.2,100.5 47.3,69.3 47.3,100.5 78.5,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.9,69.3 78.5,69.3 47.3,69.3 47.3,69.3 98.9,69.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "109.8,69.3 109.6,69.3 97.9,100.5 109.8,100.5 141,100.5 141,69.3  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.5,128 88.4,100.5 84.6,100.5 78.5,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141,100.5 109.8,100.5 97.9,100.5 94.8,109.1 86.5,131.8 109.8,131.8 141,131.8 141,131.8  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.8,131.8l-23.3,0l-8,22v9.3l31.2,0v0h0c17.3,0,31.2-14,31.2-31.2v0L109.8,131.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,131.8l-29.9,0H16v0C16,149,30,163,47.3,163h0h18.5L77.2,131.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.2,163 78.5,163 78.5,153.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "78.5,128 78.5,100.5 47.3,100.5 16,100.5 16,131.8 47.3,131.8 77.2,131.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.47f5d93be1e6a222265277298b5308b6.svg";
export { ForwardRef as ReactComponent };